import classNames from "clsx";

import { FormControlProps } from "react-bootstrap/FormControl";

import { useWindowDimensions } from "@/hooks/useWindowDimensions";

import { FormattedFormControl } from "@/components/FormControl/FormattedFormControl";
import { SkeletonWrapper } from "@/components/SkeletonWrapper";

type Props = FormControlProps & {
	skeleton?: boolean;
	skeletonWidth?: string | number;
	skeletonHeight?: string | number;
	labelClassName?: string;
	inputClassName?: string;
	containerClassName?: string;
	solid?: boolean;
};

export function Temperature({
	skeleton,
	labelClassName,
	inputClassName,
	containerClassName,
	solid = true,
	...rest
}: Props) {
	const { width } = useWindowDimensions();

	return (
		<>
			{skeleton ? (
				<SkeletonWrapper />
			) : (
				<FormattedFormControl
					labelClassName={labelClassName}
					formattedFormControlClassName={classNames(
						solid && "form-control-solid",
						inputClassName
					)}
					containerClassName={containerClassName}
					label={`Temperatura ${(width > 444 && "(°C)") || ""}`}
					mask="00.0"
					isMaskedInput
					id={rest.id}
					{...(rest as any)}
				/>
			)}
		</>
	);
}
